import script from "./SocialEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialEvents.vue?vue&type=script&setup=true&lang=js"

import "./SocialEvents.vue?vue&type=style&index=0&id=2d2c51f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2c51f0"]])

export default __exports__